import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { installmentsStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
  isUpfrontPaymentRequiredForTrial,
}) =>
  priceType === paywallPriceTypes.installments &&
  hasUpfrontPayment &&
  hasTrialPeriod &&
  isUpfrontPaymentRequiredForTrial;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  currency,
  trialPeriodDays,
  watch,
}) => {
  const totalAmount = mapCurrencyAmountStrToInt(watch("amount"));
  const upfrontPaymentAmount = mapCurrencyAmountStrToInt(
    watch("upfront_payment_amount"),
  );
  const installmentsCount = parseInt(watch("installments_count"));
  const installmentAmount = Math.round(
    (totalAmount - upfrontPaymentAmount) / installmentsCount,
  );
  const intervalType = watch("billing_frequency");

  // Locale variables
  const member_charged_immediately_phrase = t(
    [localeRoot, "phrases", "member_charged_immediately"],
    {
      amount: formatPaywallCurrencyAmount(currency, upfrontPaymentAmount),
    },
  );
  const then_member_paid_trial_phrase = t(
    [localeRoot, "phrases", "then_member_paid_trial"],
    {
      count: trialPeriodDays,
    },
  );
  const total_amount_phrase = t([localeRoot, "phrases", "total_amount"], {
    amount: formatPaywallCurrencyAmount(currency, totalAmount),
  });

  return [
    ["upfront_then_trial_then_installments", intervalType],
    {
      count: installmentsCount,
      member_charged_immediately_phrase,
      then_member_paid_trial_phrase,
      installment_amount: formatPaywallCurrencyAmount(
        currency,
        installmentAmount,
      ),
      total_amount_phrase,
    },
  ];
};

export const upfrontThenTrialThenInstallments: NoticeScenario = {
  matcher,
  stateValidator: installmentsStateValidator,
  messagePropsResolver,
};
